import Vue from "vue";
import App from "@/App.vue";
import router from './router/index'
import store from "./store/index";

import humanDate from "@/filters/humanDate";
import maxLen from "@/filters/maxLen";

Vue.config.productionTip = false;

Vue.filter('humanDate', humanDate);
Vue.filter('maxLen', maxLen);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
